import { render, staticRenderFns } from "./commonPopup.vue?vue&type=template&id=2582a891&scoped=true"
import script from "./commonPopup.vue?vue&type=script&lang=js"
export * from "./commonPopup.vue?vue&type=script&lang=js"
import style0 from "./commonPopup.vue?vue&type=style&index=0&id=2582a891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582a891",
  null
  
)

export default component.exports